import styled from "styled-components";

export const Title = styled.h4`
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
`;

